const EXPLORE_PROFILES_ENDPOINT = "cover-api/explorer-profiles/";

/**
 * Normalizes list GET responses — backends vary (DRF: results/count, others: data/items).
 */
export const parseExplorerListResponse = (data) => {
  if (data == null) return { rows: [], total: 0, pageSize: 25 };
  if (Array.isArray(data)) {
    return { rows: data, total: data.length, pageSize: 25 };
  }
  const rows =
    data.results ??
    data.data ??
    data.items ??
    data.records ??
    data.explorer_profiles ??
    data.explorerProfiles ??
    [];
  const total =
    data.count ??
    data.total ??
    data.total_count ??
    (Array.isArray(rows) ? rows.length : 0);
  const pageSize =
    Number(data.page_size ?? data.pageSize ?? data.limit ?? 25) || 25;
  return {
    rows: Array.isArray(rows) ? rows : [],
    total: Number(total) || 0,
    pageSize,
  };
};

/** GET cover-api/competitors/ — array or paginated envelope. */
export const parseCompetitorsResponse = (data) => {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  const rows =
    data.results ??
    data.data ??
    data.items ??
    data.competitors ??
    data.records ??
    [];
  return Array.isArray(rows) ? rows : [];
};

/** GET explorer-profiles/:id/comparisons/ */
export const parseComparisonsListResponse = (data) => {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  const rows = data.results ?? data.data ?? data.items ?? [];
  return Array.isArray(rows) ? rows : [];
};

export const explorePlansApi = {
  baseEndpoint: EXPLORE_PROFILES_ENDPOINT,

  list: ({ page = 1, search = "" } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    if (search?.trim()) params.set("search", search.trim());
    return `${EXPLORE_PROFILES_ENDPOINT}?${params.toString()}`;
  },

  detail: (id) => `${EXPLORE_PROFILES_ENDPOINT}${id}/`,
  create: () => EXPLORE_PROFILES_ENDPOINT,
  update: (id) => `${EXPLORE_PROFILES_ENDPOINT}${id}/`,
  publish: (id) => `${EXPLORE_PROFILES_ENDPOINT}${id}/publish/`,
  unpublish: (id) => `${EXPLORE_PROFILES_ENDPOINT}${id}/unpublish/`,
  byCover: (coverId) => `cover-api/covers/${coverId}/explorer-profile/`,

  /** Global competitor registry (names / ids for comparison columns). */
  competitorsList: () => "cover-api/competitors/",

  itineraryList: (profileId) =>
    `cover-api/explorer-profiles/${profileId}/itinerary/`,
  itineraryBulk: (profileId) =>
    `cover-api/explorer-profiles/${profileId}/itinerary/bulk/`,

  comparisonsList: (profileId) =>
    `cover-api/explorer-profiles/${profileId}/comparisons/`,
  comparisonsBulk: (profileId) =>
    `cover-api/explorer-profiles/${profileId}/comparisons/bulk/`,

  /** Single itinerary day (GET / PATCH / DELETE) */
  itineraryDay: (dayId) => `cover-api/itinerary-days/${dayId}/`,

  /** Single comparison row (GET / PATCH / DELETE) */
  comparisonRow: (rowId) => `cover-api/comparison-rows/${rowId}/`,

  /** Cover notes under a profile */
  notesList: (profileId) =>
    `cover-api/explorer-profiles/${profileId}/notes/`,
  noteDetail: (profileId, noteId) =>
    `cover-api/explorer-profiles/${profileId}/notes/${noteId}/`,
};